import { render } from "./DatasetCard.vue?vue&type=template&id=e371e34e&scoped=true"
import script from "./DatasetCard.vue?vue&type=script&lang=js"
export * from "./DatasetCard.vue?vue&type=script&lang=js"

import "./DatasetCard.vue?vue&type=style&index=0&id=e371e34e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e371e34e"]])

export default __exports__